/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from '@jutro/locale';

export default defineMessages({
    viewAllBillingsAndCancels: {
        id: 'ml.gateway.views.ActivityReports.MLDelinquentsReportComponent.VIEW ALL BILLINGS & CANCELS',
        defaultMessage: 'VIEW ALL BILLINGS & CANCELS'
    },
    noRecentBillingActivityFound: {
        id: 'ml.gateway.views.ActivityReports.MLDelinquentsReportComponent.No recent billing activity found',
        defaultMessage: 'No recent billing activity found'
    },
    notificationDate: {
        id: 'ml.gateway.views.ActivityReports.MLDelinquentsReportComponent.NOTIFICATION DATE',
        defaultMessage: 'NOTIFICATION DATE'
    },
    cancelDate: {
        id: 'ml.gateway.views.ActivityReports.MLDelinquentsReportComponent.CANCEL DATE',
        defaultMessage: 'CANCEL DATE'
    },
    customerName: {
        id: 'ml.gateway.views.ActivityReports.MLDelinquentsReportComponent.CUSTOMER NAME',
        defaultMessage: 'CUSTOMER NAME'
    },
    product: {
        id: 'ml.gateway.views.ActivityReports.MLDelinquentsReportComponent.PRODUCT',
        defaultMessage: 'PRODUCT'
    },
    policy: {
        id: 'ml.gateway.views.ActivityReports.MLDelinquentsReportComponent.POLICY #',
        defaultMessage: 'POLICY #'
    },
    description: {
        id: 'ml.gateway.views.ActivityReports.MLDelinquentsReportComponent.DESCRIPTION',
        defaultMessage: 'DESCRIPTION'
    },
    loading: {
        id: 'ml.gateway.views.ActivityReports.MLDelinquentsReportComponent.Loading...',
        defaultMessage: 'Loading...'
    },
    cancelDateRange: {
        id: 'ml.gateway.views.ActivityReports.MLDelinquentsReportComponent.Cancel Date Range',
        defaultMessage: 'Cancel Date Range'
    },
    cancellations: {
        id: 'ml.gateway.views.ActivityReports.MLDelinquentsReportComponent.Cancellations',
        defaultMessage: 'Billing and Cancellations'
    }
});
